import styled from "styled-components";
import { css } from "styled-components";
import { Root, Viewport, Scrollbar, Thumb, } from '@radix-ui/react-scroll-area';


export const ScrollRoot = styled(Root)`
  width: 100%;
  max-height: 90vh;
  height: ${(props) => props.height};
  border-radius: 4;
  overflow: hidden;
`;

export const ScrollViewport = styled(Viewport)`
  width: 100%;
  height: 100%;
  borderRadius: inherit;
  padding: 20px;
  ${(props) =>
    props.noPadding &&
    css`
      padding: 0;
    `}
`;

export const NoScroll = styled.div`
  width: 100%;
  height: fit-content;
  padding: 20px;
  max-height: 90vh;
  display:flex;
  flex-direction: column;
  ${(props) =>
    props.noPadding &&
    css`
      padding: 0;
    `}
`;

export const ScrollScrollbar = styled(Scrollbar)`
  display: flex;
  userSelect: none;
  touchAction: none;
  padding: 2;
  background: ${(props) => props.theme.colors.gray[50]};
  transition: background 160ms ease-out;
  &:hover {
    background: ${(props) => props.theme.colors.gray[200]};
  };
  &[data-orientation="vertical"]{
   width:10px;
  };
`;

export const ScrollThumb = styled(Thumb)`
  display:flex;
  flex: 1;
  background: ${(props) => props.theme.colors.scale[400]};
  border-radius: 9999px;
  position: relative;
  &::before{
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%; -50%);
    width: 100%;
    height: 100%;
    minWidth: 44px;
    minHeight: 44px;
  };
`;
